"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDuration = parseDuration;
/**
 * Converts a duration string e.g. "1h24m3s" into milliseconds.
 * @param duration
 * @returns The specified duration in milliseconds.
 */
function parseDuration(duration) {
    if (typeof duration === "number") {
        return duration;
    }
    const units = {
        d: 86400000,
        h: 3600000,
        m: 60000,
        s: 1000,
    };
    let milliseconds = 0;
    const regex = /(\d+)([dhms])/g;
    let match;
    while ((match = regex.exec(duration)) !== null) {
        const value = parseInt(match[1]);
        const unit = match[2];
        milliseconds += value * units[unit];
    }
    return milliseconds;
}
